import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { StorageManagementData } from './StorageManagementData.tsx';

const RESOURCE_TYPE_PRODUCT_JSW_STORAGE_MANAGEMENT = 'RESOURCE_TYPE_PRODUCT_JSW_STORAGE_MANAGEMENT';
const RESOURCE_TYPE_PRODUCT_JSM_STORAGE_MANAGEMENT = 'RESOURCE_TYPE_PRODUCT_JSM_STORAGE_MANAGEMENT';
const RESOURCE_TYPE_PRODUCT_JCS_STORAGE_MANAGEMENT = 'RESOURCE_TYPE_PRODUCT_JCS_STORAGE_MANAGEMENT';

export type ProductsStorageManagementResource = RouteResource<StorageManagementData>;

export const productsJswStorageManagementResource: ProductsStorageManagementResource =
	createResource<StorageManagementData>({
		type: RESOURCE_TYPE_PRODUCT_JSW_STORAGE_MANAGEMENT,
		getKey: () => 'state',
		getDataLoader: async () => {
			const mod = await import(
				/* webpackChunkName: "async-resource-products-jsw-storage-management", jiraSpaEntry: "async-resource-products-jsw-storage-management" */ './getData.tsx'
			);

			return { default: mod.getJswStorageData };
		},
	});

export const productsJsmStorageManagementResource: ProductsStorageManagementResource =
	createResource<StorageManagementData>({
		type: RESOURCE_TYPE_PRODUCT_JSM_STORAGE_MANAGEMENT,
		getKey: () => 'state',
		getDataLoader: async () => {
			const mod = await import(
				/* webpackChunkName: "async-resource-products-jsm-storage-management", jiraSpaEntry: "async-resource-products-jsm-storage-management" */ './getData.tsx'
			);

			return { default: mod.getJsmStorageData };
		},
	});

export const productsJcsStorageManagementResource: ProductsStorageManagementResource =
	createResource<StorageManagementData>({
		type: RESOURCE_TYPE_PRODUCT_JCS_STORAGE_MANAGEMENT,
		getKey: () => 'state',
		getDataLoader: async () => {
			const mod = await import(
				/* webpackChunkName: "async-resource-products-jcs-storage-management", jiraSpaEntry: "async-resource-products-jcs-storage-management" */ './getData.tsx'
			);

			return { default: mod.getJcsStorageData };
		},
	});
